export default __webpack_public_path__ + "static/media/css.3b0cb14b.png";